import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M21.746 23.25H8.064a1.5 1.5 0 0 1-1.5-1.388l-2.96-19.5A1.5 1.5 0 0 1 5.095.75H18.78a1.5 1.5 0 0 1 1.5 1.388l2.965 19.5a1.5 1.5 0 0 1-1.5 1.612ZM5.15 12.512.75 23.25"
    }, null, -1),
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m7.235 3.75 2.44 16.5h9.941l-2.44-16.5z"
    }, null, -1),
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m12.866 20.25 2.75-4.4a1.502 1.502 0 0 1 2.333-.266l1.15 1.151"
    }, null, -1),
    createElementVNode("path", {
      stroke: "currentColor",
      d: "M11.175 11.625a.375.375 0 0 1 0-.75m0 .75a.375.375 0 0 0 0-.75"
    }, null, -1)
  ]));
}
const imagePhotoFrame = { render };
export {
  imagePhotoFrame as default,
  render
};
//# sourceMappingURL=image-photo-frame.svg.js.map
